var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 80,
    viewBox: "0 0 65 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.6795 22.2563L41.9358 0.615445C41.5571 0.228902 41.041 0.00785257 40.4999 0H10.9615C5.29706 0 0.705078 4.59199 0.705078 10.2564V69.7436C0.705078 75.408 5.29706 80 10.9615 80H54.0385C59.703 80 64.295 75.408 64.295 69.7436V23.6922C64.2871 23.1513 64.0659 22.6352 63.6795 22.2563ZM42.7564 20.5129V7.17941L57.2179 21.5384H43.7819C43.2756 21.5987 42.8164 21.2371 42.7564 20.7308C42.7477 20.6585 42.7477 20.5853 42.7564 20.5129ZM60.1922 69.7436C60.1922 73.1422 57.4369 75.8974 54.0383 75.8974H10.9615C7.56292 75.8974 4.80765 73.1424 4.80765 69.7436V10.2564C4.80765 6.85784 7.56273 4.10257 10.9615 4.10257H38.6538V20.5129C38.6538 23.3451 40.9497 25.641 43.7819 25.641H60.1922V69.7436Z",
    fill: "white",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.89951f95.svg";
export { ForwardRef as ReactComponent };